import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { StickyNote, Sparkles, X } from 'lucide-react';

import { getBackendUrl } from '../utils/getBackendUrl';
const BACKEND_URL = getBackendUrl();
const API = `${BACKEND_URL}/api`;

export const SubForYou = ({ projectId, subId, notesOnly = false }) => {
  const [items, setItems] = useState([]);
  const [viewer, setViewer] = useState(null);

  const fetchItems = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/projects/${projectId}/subcontractors/${subId}/items`);
      setItems(r.data);
    } catch (e) { /* not authorized or none */ }
  }, [projectId, subId]);

  useEffect(() => { fetchItems(); }, [fetchItems]);

  const visibleItems = notesOnly ? items.filter((i) => i.type === 'note') : items;

  if (visibleItems.length === 0) return null;

  return (
    <>
    <div className="glass-card p-6 border-2 border-yellow-500/40" data-testid="sub-for-you-section">
      <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
        <Sparkles className="w-5 h-5 text-yellow-400" />
        {notesOnly ? 'Notes for You' : 'For You — Photos & Notes'}
      </h3>
      <div className="space-y-3">
        {visibleItems.map((item) => (
          <div key={item.id} className="flex items-start gap-3 p-3 rounded-lg bg-gray-50 border border-gray-200" data-testid={`for-you-item-${item.id}`}>
            {item.type === 'photo' ? (
              <button onClick={() => setViewer(item)} data-testid={`for-you-photo-${item.id}`}>
                <img
                  src={`${BACKEND_URL}${item.file_path}`}
                  alt={item.text || 'Photo'}
                  className="w-24 h-24 object-cover rounded-lg flex-shrink-0"
                />
              </button>
            ) : (
              <StickyNote className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
            )}
            <div className="min-w-0 flex-1">
              {item.text && <p className="text-gray-900 text-sm whitespace-pre-wrap">{item.text}</p>}
              <p className="text-xs text-gray-500 mt-1">
                From {item.uploaded_by_name} · {new Date(item.created_at).toLocaleDateString()}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>

    {viewer && (
      <div
        className="fixed inset-0 z-[100] flex items-center justify-center p-4"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.9)' }}
        onClick={() => setViewer(null)}
        data-testid="for-you-viewer"
      >
        <div className="max-w-4xl w-full max-h-full flex flex-col" onClick={(e) => e.stopPropagation()}>
          <div className="flex justify-end mb-2">
            <button
              onClick={() => setViewer(null)}
              className="rounded-lg px-3 py-2 min-h-[44px]"
              style={{ backgroundColor: 'rgba(15, 23, 42, 0.92)', color: '#ffffff' }}
              data-testid="for-you-viewer-close-btn"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
          <img src={`${BACKEND_URL}${viewer.file_path}`} alt={viewer.text || 'Photo'} className="w-full max-h-[70vh] object-contain rounded-lg" />
          <div
            className="mt-3 mx-auto px-4 py-2 rounded-lg text-center"
            style={{ backgroundColor: 'rgba(15, 23, 42, 0.92)', maxWidth: '92%' }}
          >
            {viewer.text && <p className="text-base" style={{ color: '#ffffff' }}>{viewer.text}</p>}
            <p className="text-sm mt-1" style={{ color: '#cbd5e1' }}>
              From {viewer.uploaded_by_name} · {new Date(viewer.created_at).toLocaleDateString()}
            </p>
          </div>
        </div>
      </div>
    )}
    </>
  );
};

export default SubForYou;
